import { Toaster as Sonner, toast } from "sonner";

/**
 * FlexFreight's one notification surface (Sonner, styled by @flexfreight/ui/toast.css), shared by the customer
 * portal and the admin console. Use `notify.success/error/...`. Errors stay until dismissed; confirmations
 * auto-dismiss. Never use window.alert.
 */
export function FfToaster({ theme }: { theme: "light" | "dark" }) {
  return (
    <Sonner
      position="bottom-right"
      theme={theme}
      gap={8}
      offset={20}
      mobileOffset={{ bottom: 88, left: 12, right: 12 }}
      visibleToasts={3}
      duration={4000}
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "fft",
          title: "fft__title",
          description: "fft__desc",
          icon: "fft__icon",
          actionButton: "fft__action",
          cancelButton: "fft__cancel",
          closeButton: "fft__close",
          success: "fft--success",
          error: "fft--error",
          warning: "fft--warning",
          info: "fft--info",
          loading: "fft--loading",
        },
      }}
    />
  );
}

/** Notifications. Errors persist until dismissed; everything else times out by importance. */
export const notify = {
  success: (title: string, description?: string) => toast.success(title, { description }),
  info: (title: string, description?: string) => toast.info(title, { description }),
  warning: (title: string, description?: string) => toast.warning(title, { description, duration: 7000 }),
  error: (title: string, description?: string) => toast.error(title, { description, duration: Infinity }),
  dismiss: (id?: string | number) => toast.dismiss(id),
};
